'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class M9 {
  static init() {
    $('.module-m9').each((index, el) => {
      new M9($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.find(".module-m9-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: true,
      // waitForAnimate: false,
      dots: false,
      // infinite: false,
      arrows: true,
      appendArrows: $el.find('.module-m9-arrows'),
      responsive: [
        {
          breakpoint: 1,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    });

    this.el.find('.m9-slick-slider').slick({
      infinite: false,
      autoplay: 1 === $el.find('.m9-slick-slider').data('slick-autoplay'),
      slidesToScroll: 1,
      slidesToShow: 1,
      // waitForAnimate: false,
      mobileFirst: true,
      arrows: true,
      appendArrows: $el.find('.module-m9-arrows'),
      // prevArrow: '<button class="slick-prev icon-left"></button>',
      // nextArrow: '<button class="slick-next icon-next"></button>',
      dots: false,
      centerPadding: '60px',
      dotsClass: 'slick-dots',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            // arrows: 0 !== $slider.data('slick-arrows'),
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }
      ]
    });
  }
}
